import styled from 'styled-components';
import theme from '../theme';

export default styled.div`
  display: flex;

  ${({ vertical, horizontal }) => vertical && !horizontal && `
    margin-bottom: ${theme.unit * 2}px;

    &:last-child {
      margin-bottom: 0;
    }
  `}
  ${({ vertical, horizontal }) => (!vertical || horizontal) && `
    margin-right: ${theme.unit}px;

    &:last-child {
      margin-right: 0;
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/blocks/Actions.js